import { Column as AriaColumn, type ColumnProps as AriaColumnProps } from "react-aria-components";
import type { ReactNode } from "react";
import { tv } from "tailwind-variants";

import { cn } from "@/lib/helpers/cn";
import SortingArrowIcon from "@/assets/images/icons2/icon--sorting-arrow.svg?component";

type Column2Props = AriaColumnProps & {
  children: ReactNode;
  className?: string;
};

export function Column2({ children, className, ...props }: Column2Props) {
  const { column, sortIndicator } = styles();

  return (
    <AriaColumn className={cn(column(), className)} {...props}>
      {children}
      {props.allowsSorting && <SortingArrowIcon aria-hidden className={sortIndicator()} />}
    </AriaColumn>
  );
}

const styles = tv({
  slots: {
    column: cn(
      "tw:group",
      "tw:px-4 tw:py-5",
      "tw:first:pl-6 tw:last:pr-6 tw:last:text-end!",
      "body-sm tw:text-text-secondary",
      "tw:cursor-default tw:outline-none",
    ),
    sortIndicator: cn(
      "tw:ml-1 tw:inline-block tw:shrink-0 tw:align-middle",
      // hidden until this column is the active sort column
      "tw:opacity-0 tw:group-data-sort-direction:opacity-100",
      "tw:group-data-[sort-direction=ascending]:rotate-180", // correct syntax
    ),
  },
});
